import React, { useEffect, useRef, useState } from "react";
import videojs from "video.js";
import { FiVideo } from "react-icons/fi";
import { lessonPlayback } from "../utils/lessonPlayback.mjs";

// Only fetch a preview for an accessible video when its row enters the viewport.
export default function ContentThumbnail({ lesson }) {
  const host = useRef(null);
  const [frame, setFrame] = useState(lesson.thumbnail || "");
  const source = lessonPlayback(lesson, process.env.API_URL || "");
  useEffect(() => {
    if (lesson.locked || frame || !source.src) return;
    let player, timer, stopped = false;
    const stop = () => { clearTimeout(timer); if (player && !player.isDisposed()) player.dispose(); };
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting) || stopped) return;
      observer.disconnect();
      const video = document.createElement("video");
      video.crossOrigin = "use-credentials"; video.muted = true; video.playsInline = true;
      const wrapper = document.createElement("div"); wrapper.hidden = true;
      host.current.appendChild(wrapper); wrapper.appendChild(video);
      player = videojs(video, { controls: false, preload: "auto", muted: true,
        html5: { vhs: { withCredentials: true, overrideNative: !videojs.browser.IS_SAFARI } },
        sources: [{ src: source.src, type: source.mimeType }] });
      player.one("loadeddata", () => {
        if (stopped) return;
        try {
          const tech = player.el().querySelector("video"), canvas = document.createElement("canvas");
          canvas.width = 320; canvas.height = 180;
          canvas.getContext("2d").drawImage(tech, 0, 0, 320, 180);
          setFrame(canvas.toDataURL("image/jpeg", 0.7));
        } catch { /* Keep the video placeholder if the browser disallows capture. */ }
        stop(); wrapper.remove();
      });
      player.one("error", stop);
      timer = setTimeout(stop, 15000);
    });
    observer.observe(host.current);
    return () => { stopped = true; observer.disconnect(); stop(); };
  }, [source.src, frame, lesson.locked]);
  return <span ref={host} className="flex h-full w-full items-center justify-center">{frame ? <img src={frame} alt="" className="h-full w-full object-cover" /> : <FiVideo className="h-8 w-8 text-gray-500" />}</span>;
}
